var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin-location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.23858 4 7 6.23858 7 9C7 11.8609 8.37029 14.6585 9.82751 16.8062C10.5475 17.8673 11.2687 18.7407 11.8094 19.3479C11.8758 19.4225 11.9395 19.4931 12 19.5594C12.0605 19.4931 12.1242 19.4225 12.1906 19.3479C12.7313 18.7407 13.4525 17.8673 14.1725 16.8062C15.6297 14.6585 17 11.8609 17 9C17 6.23858 14.7614 4 12 4ZM12 21C11.3121 21.7258 11.3119 21.7256 11.3117 21.7254L11.3095 21.7233L11.3046 21.7187L11.2885 21.7032C11.275 21.6901 11.2559 21.6716 11.2317 21.6478C11.1832 21.6002 11.114 21.5313 11.0271 21.4424C10.8534 21.2647 10.6083 21.0065 10.3156 20.6779C9.7313 20.0216 8.95254 19.0788 8.17249 17.9291C6.62971 15.6552 5 12.4528 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 12.4528 17.3703 15.6552 15.8275 17.9291C15.0475 19.0788 14.2687 20.0216 13.6844 20.6779C13.3917 21.0065 13.1466 21.2647 12.9729 21.4424C12.886 21.5313 12.8168 21.6002 12.7683 21.6478C12.7441 21.6716 12.725 21.6901 12.7115 21.7032L12.6954 21.7187L12.6905 21.7233L12.6889 21.7248C12.6887 21.725 12.6879 21.7258 12 21ZM12 21L12.6879 21.7258C12.3021 22.0914 11.6974 22.091 11.3117 21.7254L12 21ZM12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8ZM9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z",
    fill: "#E31E24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.efa2b2a92ba907340ec3b40ad0553743.svg";
export { ForwardRef as ReactComponent };